import { useEffect } from "react";

export const useScrollToTop = (deps: unknown[] = []) => {
  useEffect(() => {
    window.scrollTo({
      behavior: "smooth",
      top: 0,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
